"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getContent_1 = require("../../helpers/getContent");
const getState_1 = require("../../helpers/getState");
const getStateInteraction_1 = require("../../helpers/getStateInteraction");
const getRating = (rating) => parseInt(rating || '0', 10);
function getAllReviewSum(peerReviewStateInteractions, peerQuestionIndex, minGetReviewedCount) {
    const allReviewsSum = peerReviewStateInteractions
        .map((interaction) => interaction.reviews[peerQuestionIndex])
        .filter(item => !!item)
        .sort((review1, review2) => getRating(review2.rating) - getRating(review1.rating))
        .map(review => getRating(review.rating))
        .slice(0, minGetReviewedCount)
        .reduce((p, c) => p + c, 0);
    return allReviewsSum;
}
// Currently for calculating raw score from all
// peer questions, this methods calculates best
// 3 (or minGetReviewedCount) for first question
// then for second and so on.
function getQuestionRawScore(command, content, peerReviewStateInteractions) {
    const { contentId: cardQuestionForReviewId } = command;
    const cardQuestionForReview = getContent_1.getContentByContentId(content, cardQuestionForReviewId);
    let questionRawScore = 0;
    cardQuestionForReview.children.forEach((peerQuestion, peerQuestionIndex) => {
        const minGetReviewedCount = peerQuestion.minGetReviewedCount;
        const allReviewsSum = getAllReviewSum(peerReviewStateInteractions, peerQuestionIndex, minGetReviewedCount);
        const averageScore = allReviewsSum / minGetReviewedCount;
        questionRawScore = questionRawScore + averageScore;
    });
    return questionRawScore;
}
function addReviewsReceived(command, content, allStates, allStateInteractions) {
    const { reviewedAssignmentQuestionId, receiverId: userId, reviewedSubmissionId, timeStamp } = command;
    // Calculate raw_score for assignment card.
    const peerReviewStateInteractions = getStateInteraction_1.getPeerReviewStateInteractions(allStateInteractions, reviewedAssignmentQuestionId, userId, reviewedSubmissionId);
    const questionRawScore = getQuestionRawScore(command, content, peerReviewStateInteractions);
    const cardQuestionState = getState_1.getStateByContentIdUserId(allStates, reviewedAssignmentQuestionId, userId);
    cardQuestionState.submissions[0].rawScore = questionRawScore;
    cardQuestionState.rawScore = questionRawScore;
    // addQuestionReviews from submission
    // because when assignment gets resubmit then review count in submission in initialized to 0
    const reviewsReceivedCount = peerReviewStateInteractions.length;
    cardQuestionState.submissions[0].reviewsReceivedCount = reviewsReceivedCount;
    cardQuestionState.reviewsReceivedCount = reviewsReceivedCount;
    cardQuestionState.updatedAt = timeStamp;
    return cardQuestionState;
}
exports.default = addReviewsReceived;
//# sourceMappingURL=addReviewsReceived.js.map